import { defineStore } from "pinia";
import axios from "axios";
import { debugLog } from "@/shared/utils";

export const useDataStore = defineStore("data", {
  state: () => ({
    data: {},
    params: {},
    url: "",
    loading: {
      veranstaltungen: false
    },
    otherInfo: {
      apothekenfinder: {},
      veranstaltungen: {},
    },
    page: 1,
    formLoad: true,
    firstLoad: true,
    pluginType: null,
  }),
  actions: {
    setUrl(url) {
      this.url = url;
    },
    setParams(params) {
      this.params = params;
    },
    setData(data) {
      this.data = data
    },
    setPage(page) {
      this.page = page;
    },
    setFormLoad(load) {
      this.formLoad = load;
    },
    setFirstLoad(load) {
      this.firstLoad = load;
    },
    setPluginType(pluginType) {
      this.pluginType = pluginType
    },
    callApi(options = {}) {
      if(!this.url.length) return;
      // CREATE STRING WITH PARAMS
      const url = new URL(this.url);
      const params = new URLSearchParams();
      let path = url.searchParams.get("tx_apis_calluniplus[path]");
      let paramsIn = this.params;
      
      if(options.params){
        paramsIn = {...paramsIn, ...options.params};
      }
      const paramKeys = Object.keys(paramsIn);
      
      if (paramKeys.length) {
        paramKeys.forEach((key) => {
          if(paramsIn[key]?.toString().length && paramsIn[key] !== "*" && paramsIn[key] !== "-1"){
          params.append(key, paramsIn[key]);}
        });
        path += "?" + params.toString();
        url.searchParams.set("tx_apis_calluniplus[path]", path);
      }
      debugLog(url.toString());
      

      // CALL
      if(typeof options?.beforeStart == "function") options.beforeStart();
     let urlOut = url.toString();
      if(options?.cache === false){
        urlOut += "&time=" + new Date().getTime();
      }
      axios
        .get(urlOut)
        .then(({ data }) => {
         debugLog(data);
          this.data = data;
        })
        .catch((err) => {
            console.error(err);
        })
        .finally(() => {
          if(typeof options?.afterEnd == "function") options.afterEnd();
        });
    },
  },
});
